import { immerable } from 'immer'
import { useState, useRef } from 'react'
import api from '@/services/api/folders.js'
import titleCase from '@/utils/title-case'
import KeyHelper from '@/utils/key-helper'

class Folder {

	[immerable] = true

	constructor(params) {
		this.name = params.name
		this.status = params.status
		this.referenceNumber = params.referenceNumber
		this.template = params.template
		this.templateId = params.templateId
		this.expectedDateOfCompletion = params.expectedDateOfCompletion
		this.dataElements = params.dataElements;
		this.recipients = params.recipients
		this.id = params.id
		this.$selected = false
	}
}

const useFolders = () => {

	const [items, setItems] = useState([])
	const [meta, setMeta] = useState(null)
	const [currentItem, setCurrentItem] = useState([])
	const [loading, setLoading] = useState(false)
	const [error, setErrorMsg] = useState()

	const lastRequestPayloadKeyRef = useRef(null)

	async function fetch(payload) {
		const currentPayloadKey = KeyHelper.createKeyOfObject({ payload })

		if(KeyHelper.isSameKey(lastRequestPayloadKeyRef.current, currentPayloadKey)) return;

		lastRequestPayloadKeyRef.current = currentPayloadKey

		setLoading(true)
		const params = payload || {};

		const [error, response] = await api.index(params);
		setLoading(false)

		if (error) {
			setLoading(false);
			return setErrorMsg(error);
		}
		const { items, meta } = response
		setItems(items);
		setMeta(meta);

	}

	async function create(type, payload) {
		return new Promise(async (resolve, reject) => {
			setLoading(true)
			const [error, response] = await api.create(type, payload)
			setLoading(false)
			if (error) {
				return reject(error)
			}

			return resolve(response)
		})
	}

	async function update(id, payload) {
		setLoading(true);

		const [error, response] = await api.update(id, payload);

		setLoading(false);

		if (error) {
			return setErrorMsg(error);
		}
	}

	async function get(id, params) {
		setLoading(true);

		const [error, response] = await api.get(id, params);
		setLoading(false);

		setCurrentItem(response)

		if (error) {
			return setErrorMsg(error);
		}


	}

	async function rename(id, payload) {
		return new Promise(async (resolve, reject) => {
			setLoading(true)
			const [error, response] = await api.rename(id, payload)
			setLoading(false)
			if (error) {
				return reject(error)
			}

			return resolve(response)
		})
	}

	async function deleteFolder(id, payload) {
		return new Promise(async (resolve, reject) => {
			setLoading(true)
			const [error, response] = await api.delete(id)
			setLoading(false)
			if (error) {
				return reject(error)
			}

			return resolve(response)
		})
	}

	function serialize(entry) {
		return {
			"id": entry.id,
			"name": entry.name,
			"referenceNumber": entry.referenceNumber,
			"template": entry.template,
			"templateId": entry.templateId,
			"expectedDateOfCompletion": entry.expectedDateOfCompletion,
			"dataElements": entry.dataElements,
			"recipients": entry.recipients,
		}
	}

	function view(id) {
		const newCurrentItem = items.find(item => item.id === id)
		setCurrentItem(newCurrentItem)
	}

	return {
		create,
		currentItem,
		error,
		fetch,
		items,
		loading,
		meta,
		update,
		setCurrentItem,
		setItems,
		view,
		get,
		rename,
		deleteFolder
	}

}

export default useFolders;
